import { Component, OnDestroy } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { ContentState } from '../../../store/state/content.state';
import { Subject } from 'rxjs';
import { RESOURCES4U_URL } from '../../../app.constants';
import { Title } from '@angular/platform-browser';
import { setTitleComponent } from 'src/app/utils/titles.util';
@Component({
    selector: 'u4-cpp-resources4u',
    templateUrl: './resources4u.component.html',
    styleUrls: ['./resources4u.component.scss']
})
export class Resources4uComponent implements OnDestroy {
    public labels: { [key: string]: string };
    public redirectUrl = RESOURCES4U_URL;
    private destroy$: Subject<void> = new Subject<void>();

    constructor(
        private store: Store<ContentState>,
        private titleService: Title)
    {
        this.store.select(state => state.labels).pipe(
            takeUntil(this.destroy$)
        ).subscribe(labels => { 
            this.labels = labels;
            this.titleService.setTitle(setTitleComponent(this.labels['resources4u.title']));
        });
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

}
